import React, { useEffect, useState } from 'react';
import RouteProvider from 'hooks/routeProvider';
import configService from 'service/configService';
import { Result } from 'antd';
export default () => {
  const [configJson, setConfigJson] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const getConfig = async () => {
      const configJson = await configService.initConfig();
      setConfigJson(configJson);
      setLoaded(true);
      if (configJson) {
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${configJson.REACT_APP_GOOGLE_MAP_API_KEY}&v=3.64&libraries=geometry,drawing,places&callback=initMap`;
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
        window.initMap = () => {
          if (typeof google === 'undefined') {
            console.error('Google Maps API is not loaded.');
            return;
          }
          console.log('Google Maps API loaded successfully');
        };
      }
    };
    getConfig();
  }, []);
  return (
    <div className="App">
      {configJson ? (
        <RouteProvider configJson={configJson} />
      ) : (
        loaded && (
          <Result
            status="500"
            title="500"
            subTitle="Üzgünüz, bir şeyler ters gitti."
          />
        )
      )}
    </div>
  );
};
